module.exports = __webpack_public_path__ + "static/img/lin.94a60a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lin.jpg
// module id = chZi
// module chunks = 1